<template>
	<div>
		<div class="row mb-2">
			<div class="col-5">
				<h1>{{$t('dashboard')}}</h1>
			</div>
			<div class="col-7">
				<MenuModalBtn class="float-right"/>
			</div>
		</div>
		<div class="row">

			<div class="col-12 col-lg-4 order-lg-12 mb-4">

				<div class="widget mb-4 p-8">
					<UserWidget />
				</div>

				<MessagesWidget limit="3" unread="1" class="mb-4"></MessagesWidget>

				<div class="mb-4" v-if="$config.hasModule('timetable') && !isTeacher && $UserSession.hasPriv('TIMETABLE_VIEW')">
					<TimetableWidget />
				</div>

				<RecentlyMarkedWidget limit="3" v-if="$UserSession.hasPriv('TREATMENTSESSION_EDIT') && !isTeacher" />

			</div>

			<div class="col-12 col-lg-8 order-lg-1">

				<MyPlacementsWidget class="mb-4" v-if="!$UserSession.hasPriv('ALL') && $UserSession.hasPriv('PLACEMENT_MY_PLACEMENTS')"></MyPlacementsWidget>

				<ProgressWidget class="mb-4" v-if="!isTeacher && $UserSession.hasPriv('REPORT_CLINICALEXPERIENCE')" />

				<TeacherProgressWidget class="mb-4" v-if="isTeacher && $UserSession.hasPriv('REPORT_TEACHERMYPROGRESS')" />

				<ClinicalWidget limit="3" class="mb-4" v-if="$config.hasModule('clinical') && $UserSession.hasPriv('TREATMENTSESSION_EDIT')" />

				<FormsWidget class="mb-4" v-if="$UserSession.hasPriv('APP_TEACHER') || $UserSession.hasPriv('APP_STUDENT')" list="requiringattention" limit="5" :header="$t('forms')"></FormsWidget>

				<TestsWidget class="mb-4" v-if="$UserSession.hasPriv('TESTS') && this.$UserSession.hasPriv('APP_TEACHER')" list="requiringattention" limit="5" :header="$t('tests')"></TestsWidget>

			</div>
		</div>
	</div>
</template>

<script>
import MenuModalBtn from "src/components/Workflows/MenuModalBtn.vue";
import UserWidget from "src/components/widgets/UserWidget";
import MessagesWidget from "src/components/widgets/MessagesWidget";
import ProgressWidget from "src/components/widgets/ProgressWidget";
import TeacherProgressWidget from "src/components/widgets/TeacherProgressWidget";
import ClinicalWidget from "src/components/widgets/ClinicalWidget";
import FormsWidget from "src/components/widgets/FormsWidget"
import TestsWidget from "src/components/widgets/TestsWidget"
import RecentlyMarkedWidget from "src/components/widgets/RecentlyMarkedWidget";
import TimetableWidget from "src/components/widgets/TimetableWidget";
import MyPlacementsWidget from "src/components/widgets/MyPlacementsWidget";

export default {
	components: {
		MenuModalBtn,
		UserWidget,
		MessagesWidget,
		ProgressWidget,
		TeacherProgressWidget,
		ClinicalWidget,
		FormsWidget,
		TestsWidget,
		RecentlyMarkedWidget,
		TimetableWidget,
		MyPlacementsWidget
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		}
	}
};
</script>
